export default __webpack_public_path__ + "static/media/gls-gl.530bc895.svg";